export default [
  {
    // 1-1
    path: "/SciencePeopleUnit/AcaWorkstation",
    name: "AcaWorkstation",
    component: () => import("../views/SciencePeopleUnit/AcaWorkstation"),
  },
  {
    // 1-2
    path: "/SciencePeopleUnit/ScholarWorkStation",
    name: "ScholarWorkStation",
    component: () => import("../views/SciencePeopleUnit/ScholarWorkStation"),
  },
  {
    // 1-3
    path: "/SciencePeopleUnit/SciInstitution",
    name: "SciInstitution",
    component: () => import("../views/SciencePeopleUnit/SciInstitution"),
  },
  {
    // 1-4
    path: "/SciencePeopleUnit/SciCommissioner",
    name: "SciCommissioner",
    component: () => import("../views/SciencePeopleUnit/SciCommissioner"),
  },
  {
    // 1-5
    path: "/SciencePeopleUnit/SciVicePresident",
    name: "SciVicePresident",
    component: () => import("../views/SciencePeopleUnit/SciVicePresident"),
  },
];
